import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {SubmitType} from '../../../../shared/models/submit.type';
import {Subscription} from 'rxjs';
import {DataSourceFacade} from '../../../facade/data-source.facade';
import {DataSource} from '../../../models/data-source.modol';
import {NbDialogRef} from '@nebular/theme';
import {ColumnsType} from '../../../models/columns-type.model';

@Component({
    selector: 'morva-data-source-warning-message-dialog',
    templateUrl: './data-source-warning-message-dialog.component.html',
    styleUrls: ['./data-source-warning-message-dialog.component.scss'],
})
export class DataSourceWarningMessageDialogComponent implements OnInit, OnDestroy {
    title: string;
    warnings: string[];
    submitState: SubmitType;
    subscriptions: Subscription[] = [];
    dataSource: DataSource;
    columnsTypes: ColumnsType;
    type: 'updateDatasourceData' | 'updateDatasourceColumnTypes'|'simple';
    message: string;

    constructor(
        private dialogRef: NbDialogRef<any>,
        private changeDetectorRef: ChangeDetectorRef,
        private dataSourceFacade: DataSourceFacade) {
    }

    ngOnInit(): void {
      if(this.type !== 'simple') {
        this.subscriptions.push(this.dataSourceFacade.getSubmitState$().subscribe(
          (submitState) => {
            this.submitState = submitState;
            if (this.submitState === 'submitted') {
              this.dataSourceFacade.setSubmitState('notSubmitted');
              this.close();
            } else if (this.submitState === 'submittedWithError') {
              this.dataSourceFacade.setSubmitState('notSubmitted');
            }
            this.changeDetectorRef.detectChanges();
          },
        ));
        this.subscriptions.push(this.dataSourceFacade.getDataSource$()
          .subscribe(dataSource => {
            this.dataSource = dataSource;
            if (this.type === 'updateDatasourceData') {
              this.message = `آﯾﺎ با به‌روزرسانی اجباری منبع داده “${dataSource.name}” موافق هستید؟`;
            } else if (this.type === 'updateDatasourceColumnTypes') {
              this.message = 'آیا از ذخیره تغییرات در نوع داده ستون‌ها اطمینان دارید؟';
            }
          }));
      }
    }

    forceUpdate(): void {
        if(this.type === 'updateDatasourceData') {
            this.dataSourceFacade.updateDatasourceData(this.dataSource.workspaceId, this.dataSource.id);
        } else if (this.type === 'updateDatasourceColumnTypes') {
            this.dataSourceFacade.updateDatasourceColumnsDataTypes(this.dataSource.workspaceId,
                this.dataSource.id, this.columnsTypes);
        }else if(this.type === 'simple'){
          this.dialogRef.close(true);
        }
    }

    close(): void {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
